import type { BackofficePurchaseOrder } from '../redux/backoffice/suppliersSlice';
import type { FormSelectOption } from '../components/Reusables/FormSelectField.types';

type PurchaseOrderRef = Pick<
  BackofficePurchaseOrder,
  '_id' | 'bp_purchase_order_number' | 'bp_purchase_order_status'
>;

export function canCreateGoodsReceipt(
  po: PurchaseOrderRef | null | undefined,
): boolean {
  const status = po?.bp_purchase_order_status;
  return status === 'sent' || status === 'partially_fulfilled';
}

export function canResendPurchaseOrder(
  po: PurchaseOrderRef | null | undefined,
): boolean {
  const status = po?.bp_purchase_order_status;
  return status === 'sent' || status === 'partially_fulfilled';
}

export function canAddInvoiceForPO(
  po: PurchaseOrderRef | null | undefined,
): boolean {
  const status = po?.bp_purchase_order_status;
  return (
    status === 'sent' ||
    status === 'partially_fulfilled' ||
    status === 'fulfilled'
  );
}

export function isPurchaseOrderCancelled(
  po: Pick<BackofficePurchaseOrder, 'bp_purchase_order_status'> | null | undefined,
): boolean {
  const status = po?.bp_purchase_order_status;
  return status === 'cancelled' || status === 'canceled';
}

export function formatPurchaseOrderPickerLabel(po: PurchaseOrderRef): string {
  const id = String(po._id || '');
  const number =
    po.bp_purchase_order_number || `Purchase order ${id.slice(-6)}`;
  const status = po.bp_purchase_order_status;
  return status ? `${number} (${status})` : number;
}

export function toGoodsReceiptPurchaseOrderOption(
  po: BackofficePurchaseOrder,
): FormSelectOption {
  return {
    label: formatPurchaseOrderPickerLabel(po),
    value: String(po._id),
  };
}

export function getGoodsReceiptBlockedMessage(
  status: BackofficePurchaseOrder['bp_purchase_order_status'] | null | undefined,
): string {
  if (status === 'cancelled' || status === 'canceled') {
    return 'This purchase order is cancelled and cannot be used.';
  }
  if (status === 'fulfilled') {
    return 'This purchase order is fulfilled and cannot be used.';
  }
  if (status === 'draft') {
    return 'This purchase order is still a draft and cannot be used.';
  }
  return 'Only sent or partially fulfilled purchase orders can be used.';
}
